import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../utils/axios";
const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchTiktokRaw = createAsyncThunk(
  "tiktokRawData/fetchTiktokRaw",

  async ({ lte, gte, interval }) => {
    const response = await axiosInstance.request({
      url: `tiktok/raw`,
      method: `GET`,
      params: {
        lte,
        gte,
        interval,
      },
    });
    return response;
  }
);

const tiktokRawDataSlice = createSlice({
  name: "tiktokRawData",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchTiktokRaw.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTiktokRaw.fulfilled, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.data = action.payload.data;
      })
      .addCase(fetchTiktokRaw.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const TiktokRawDataReducer = tiktokRawDataSlice.reducer;

export default TiktokRawDataReducer;

export const tiktokRawDataAction = tiktokRawDataSlice.actions;
